
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { Separator } from '@/components/ui/separator';
import { Globe } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

interface GeneralSettingsSectionProps {
  settings: {
    siteName: string;
    supportEmail: string;
    maintenanceMode: boolean;
  };
  updateSetting: (key: string, value: any) => void;
}

const GeneralSettingsSection = ({ settings, updateSetting }: GeneralSettingsSectionProps) => {
  const { t } = useLanguage();

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Globe className="h-5 w-5" />
          {t('general_settings', 'الإعدادات العامة', 'General Settings')}
        </CardTitle>
        <CardDescription>
          {t('basic_site_configuration', 'إعدادات الموقع الأساسية', 'Basic site configuration')}
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label htmlFor="siteName">
              {t('site_name', 'اسم الموقع', 'Site Name')}
            </Label>
            <Input
              id="siteName"
              value={settings.siteName}
              onChange={(e) => updateSetting('siteName', e.target.value)}
              placeholder="Enter site name"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="supportEmail">
              {t('support_email', 'بريد الدعم', 'Support Email')}
            </Label>
            <Input
              id="supportEmail"
              type="email"
              value={settings.supportEmail}
              onChange={(e) => updateSetting('supportEmail', e.target.value)}
              placeholder="Enter support email"
            />
          </div>
        </div>
        
        <Separator />
        
        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <Label>{t('maintenance_mode', 'وضع الصيانة', 'Maintenance Mode')}</Label>
            <p className="text-sm text-muted-foreground">
              {t('maintenance_mode_desc', 'تفعيل وضع الصيانة للموقع', 'Enable maintenance mode for the site')}
            </p>
          </div>
          <Switch
            checked={settings.maintenanceMode}
            onCheckedChange={(checked) => updateSetting('maintenanceMode', checked)}
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default GeneralSettingsSection;
